import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';

/**
 * React-based ModalProvider to handle alert and confirm via Context and Portal.
 * Exposes window.openAlert and window.openConfirm for legacy compatibility.
 */
export const ModalProvider = ({ children }) => {
  const [alertOptions, setAlertOptions] = useState(null);
  const [confirmOptions, setConfirmOptions] = useState(null);

  const showAlert = useCallback(({ title = '알림', description = '', response_method }) => {
    //console.log('ModalProvider.showAlert', { title, description, response_method });
    setAlertOptions({ title, description, response_method });
  }, []);

  const closeAlert = useCallback(() => {
    setAlertOptions(null);
  }, []);

  const showConfirm = useCallback(({ title = '알림', description = '', positive_method, positive_param, negative_method, negative_param, positive_btn = '예', negative_btn = '아니요' }) => {
    setConfirmOptions({ title, description, positive_method, positive_param, negative_method, negative_param, positive_btn, negative_btn });
  }, []);

  const closeConfirm = useCallback(() => {
    setConfirmOptions(null);
  }, []);

  // Expose functions to window for global calls
  useEffect(() => {
    window.openAlert = showAlert;
    window.openConfirm = showConfirm;
    // Override native alert to use React modal
    const originalAlert = window.alert;
    window.alert = msg => showAlert({ title: '알림', description: String(msg) });
    return () => {
      delete window.openAlert;
      delete window.openConfirm;
      window.alert = originalAlert;
    };
  }, [showAlert, showConfirm]);

  return (
    <>
      {children}

      {alertOptions && ReactDOM.createPortal(
        <div className="modal_wrap" style={{ display: 'flex', zIndex: 9999 }}>
          <div className="modal common">
            <h6>{alertOptions.title}</h6>
            <p dangerouslySetInnerHTML={{ __html: alertOptions.description.replace(/\n/g, '<br/>') }} />
            <ul className="common_btn">
              <li className="complete" onClick={() => {
                closeAlert();
                if (alertOptions.response_method) {
                  const cb = alertOptions.response_method;
                  if (typeof cb === 'function') {
                    cb();
                  } else if (typeof window[cb] === 'function') {
                    window[cb]();
                  }
                }
              }}>
                확인
              </li>
            </ul>
          </div>
        </div>,
        document.body
      )}

      {confirmOptions && ReactDOM.createPortal(
        <div className="modal_wrap" style={{ display: 'flex', zIndex: 9999 }}>
          <div className="modal common">
            <h6>{confirmOptions.title}</h6>
            <p dangerouslySetInnerHTML={{ __html: confirmOptions.description.replace(/\n/g, '<br/>') }} />
            <ul className="common_btn">
              <li className="primary" onClick={() => {
                closeConfirm();
                if (confirmOptions.positive_method) {
                  const pm = confirmOptions.positive_method;
                  const pp = confirmOptions.positive_param;
                  if (typeof pm === 'function') {
                    pm(pp);
                  } else if (typeof window[pm] === 'function') {
                    window[pm](pp);
                  }
                }
              }}>
                {confirmOptions.positive_btn}
              </li>
              <li className="tertiary" onClick={() => {
                closeConfirm();
                if (confirmOptions.negative_method) {
                  const nm = confirmOptions.negative_method;
                  const np = confirmOptions.negative_param;
                  if (typeof nm === 'function') {
                    nm(np);
                  } else if (typeof window[nm] === 'function') {
                    window[nm](np);
                  }
                }
              }}>
                {confirmOptions.negative_btn}
              </li>
            </ul>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};
